var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgShadowFooter = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 1920,
  height: 747,
  viewBox: "0 0 1920 747",
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  opacity: 0.15,
  filter: "url(#filter0_f_3992_598)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 300,
  y: -422,
  width: 872,
  height: 710,
  rx: 355,
  fill: "#36F3FF"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.15,
  filter: "url(#filter1_f_3992_598)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 748,
  y: -422,
  width: 872,
  height: 710,
  rx: 355,
  fill: "#7636FF"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_f_3992_598",
  x: -159,
  y: -881,
  width: 1790,
  height: 1628,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 229.5,
  result: "effect1_foregroundBlur_3992_598"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_f_3992_598",
  x: 289,
  y: -881,
  width: 1790,
  height: 1628,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 229.5,
  result: "effect1_foregroundBlur_3992_598"
})))));
export default SvgShadowFooter;